import { ApplicationConfig, provideZonelessChangeDetection } from '@angular/core';
import { HttpClient, provideHttpClient, withInterceptors } from '@angular/common/http';
import { importProvidersFrom } from '@angular/core';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { PreloadAllModules, provideRouter, withPreloading } from '@angular/router';
import { providePrimeNG } from 'primeng/config';
import { MessageService } from 'primeng/api';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { appRoutes } from './app.routes';
import { AssetsTranslateLoader } from './core/i18n/assets-translate-loader';
import { provideSharedUi } from './shared/shared-imports';
import { CrimsonNoirPreset } from './shared/primeng-color-preset';
import { authInterceptor } from './core/services/http/auth.interceptor';
import { errorInterceptor } from './core/services/http/error.interceptor';
import { loadingInterceptor } from './core/services/http/loading.interceptor';
import { GEO_DATA_PROVIDER } from './core/services/geo/geo-data.provider';
import { LocalJsonGeoProvider } from './core/services/geo/providers/local-json-geo.provider';

export function httpTranslateLoaderFactory(http: HttpClient): TranslateLoader {
  return new AssetsTranslateLoader(http);
}

export const appConfig: ApplicationConfig = {
  providers: [
    /**
     * Ordre d'exécution des interceptors :
     *  1. authInterceptor    → active `withCredentials` pour l'API (cookie HttpOnly)
     *  2. loadingInterceptor → incrémente le compteur global de requêtes en vol
     *  3. errorInterceptor   → catch & route les erreurs HTTP (401, 403, 500…)
     */
    provideHttpClient(withInterceptors([authInterceptor, loadingInterceptor, errorInterceptor])),
    provideAnimationsAsync(),
    provideRouter(appRoutes, withPreloading(PreloadAllModules)),
    provideSharedUi(),
    importProvidersFrom(
      TranslateModule.forRoot({
        defaultLanguage: 'en',
        loader: {
          provide: TranslateLoader,
          useFactory: httpTranslateLoaderFactory,
          deps: [HttpClient],
        },
      }),
    ),
    providePrimeNG({
      theme: {
        preset: CrimsonNoirPreset,
        options: {
          darkModeSelector: '.my-app-dark',
        },
      },
    }),
    MessageService,
    provideZonelessChangeDetection(),
    { provide: GEO_DATA_PROVIDER, useClass: LocalJsonGeoProvider },
  ],
};
